import { render, staticRenderFns } from "./PageAdminTerminology.vue?vue&type=template&id=819a8ef2"
import script from "./PageAdminTerminology.vue?vue&type=script&lang=js"
export * from "./PageAdminTerminology.vue?vue&type=script&lang=js"
import style0 from "./PageAdminTerminology.vue?vue&type=style&index=0&id=819a8ef2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports